<div class="content-block">

  <!-- Content Header (Page header) -->

  <div class="content-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          <h1 class="m-0 text-dark">Parametri di stampa </h1>
        </div><!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
            <li class="breadcrumb-item">Parametri</li>
            <li class="breadcrumb-item active">Stampa</li>
          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->

  <div class="content-block">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="nav-tabs-custom">
            <ul class="nav nav-pills">
              @if (gestDPI) {
                <li class="nav-item"><a class="nav-link active" href="#parametri-dpi" data-bs-toggle="tab">Prametri DPI</a></li>
              }
              @if (gestDOTAZIONI) {
                <li class="nav-item"><a class="nav-link" href="#parametri-dotazioni" data-bs-toggle="tab">Parametri DOTAZIONI</a></li>
              }
            </ul>
          </div>
          <div class="card-body">
            <div class="tab-content">
              @if (gestDPI) {
                <div class="active tab-pane" id="parametri-dpi">
                  <app-form-parametri-stampa [tipoparstampa]="'DPI'"></app-form-parametri-stampa>
                </div>
                }<!-- /.tab-pane -->

                @if (gestDOTAZIONI) {
                  <div class="tab-pane" id="parametri-dotazioni">
                    <app-form-parametri-stampa [tipoparstampa]="'DOTAZIONI'"></app-form-parametri-stampa>
                  </div>
                  }<!-- /.tab-pane -->

                </div> <!-- fine tab-content-->

              </div><!-- fine card-body-->
            </div> <!--fine card-->
          </div>
        </div>

      </div>





    </div>

